import React from 'react';
import { Button } from '../../components/ui/Button';
import { Plus } from 'lucide-react';
const sampleUsers = [{
  name: 'Md. Rahim Uddin',
  email: 'rahim.admin@bandarban.gov.bd',
  role: 'Super Admin',
  status: 'Active',
  lastLogin: '১৯ মে ২০২৬, ০৯:৩০ AM'
}, {
  name: 'Nusrat Jahan',
  email: 'nusrat.report@bandarban.gov.bd',
  role: 'Report Viewer',
  status: 'Active',
  lastLogin: '১৮ মে ২০২৬, ০৪:১৫ PM'
}, {
  name: 'Abdul Karim',
  email: 'karim.ticket@bandarban.gov.bd',
  role: 'Admin',
  status: 'Active',
  lastLogin: '১৯ মে ২০২৬, ১০:০০ AM'
}, {
  name: 'Farhana Akter',
  email: 'farhana.accounts@bandarban.gov.bd',
  role: 'Admin',
  status: 'Inactive',
  lastLogin: '১২ মে ২০২৬, ০৩:৪০ PM'
}];
export function Users() {
  return <div className="space-y-6" data-id="element-445">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4" data-id="element-446">
        <div data-id="element-447">
          <h1 className="text-2xl font-bold text-slate-900" data-id="element-448">
            ব্যবহারকারী ব্যবস্থাপনা
          </h1>
          <p className="text-slate-500" data-id="element-449">
            সিস্টেম অ্যাডমিন এবং ব্যবহারকারীদের তালিকা
          </p>
        </div>
        <Button className="gap-2" data-id="element-450">
          <Plus className="w-4 h-4" data-id="element-451" />
          নতুন ব্যবহারকারী
        </Button>
      </div>

      <div className="bg-white rounded-2xl border border-slate-200 shadow-sm overflow-hidden" data-id="element-452">
        <div className="overflow-x-auto" data-id="element-453">
          <table className="w-full text-sm text-left" data-id="element-454">
            <thead className="text-xs text-slate-500 bg-slate-50 uppercase" data-id="element-455">
              <tr data-id="element-456">
                <th className="px-6 py-4 font-medium" data-id="element-457">Name</th>
                <th className="px-6 py-4 font-medium" data-id="element-458">Email</th>
                <th className="px-6 py-4 font-medium" data-id="element-459">Role</th>
                <th className="px-6 py-4 font-medium" data-id="element-460">Status</th>
                <th className="px-6 py-4 font-medium" data-id="element-461">Last Login</th>
                <th className="px-6 py-4 font-medium text-right" data-id="element-462">Actions</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100" data-id="element-463">
              {sampleUsers.map((user, i) => <tr key={i} className="hover:bg-slate-50" data-id="element-464">
                  <td className="px-6 py-4 font-medium text-slate-900" data-id="element-465">
                    {user.name}
                  </td>
                  <td className="px-6 py-4 text-slate-500" data-id="element-466">{user.email}</td>
                  <td className="px-6 py-4" data-id="element-467">
                    <span className="inline-flex px-2.5 py-1 rounded-md text-xs font-medium bg-slate-100 text-slate-700" data-id="element-468">
                      {user.role}
                    </span>
                  </td>
                  <td className="px-6 py-4" data-id="element-469">
                    <span className={`inline-flex px-2.5 py-1 rounded-full text-xs font-medium ${user.status === 'Active' ? 'bg-brand-green/10 text-brand-green' : 'bg-slate-100 text-slate-500'}`} data-id="element-470">
                      {user.status}
                    </span>
                  </td>
                  <td className="px-6 py-4 text-slate-500" data-id="element-471">{user.lastLogin}</td>
                  <td className="px-6 py-4 text-right" data-id="element-472">
                    <Button variant="ghost" size="sm" className="text-brand-coral hover:text-brand-coral hover:bg-brand-coral/10" data-id="element-473">
                      Edit
                    </Button>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>;
}